//! main.js
// Specify the element in html to designate the location where 'app.js' will be displayed.
// This file usually exists only as one file, and plays a role in placing various 'app.js' and files that make app.js work.
//! app.js
// Specify movie-app to be shown in the part called 'router-view' before 'main.js'.
// This part exist as one file because Im making one app(movie-app) now,
// but there is room for the name to be changed if you create multiple apps in the future.
// Also, can specify the screen (header, footer, sidebar) to be fixed and displayed on all pages.
//! 'youjun.js' is in charge of the most fundamental logical structure.
///? Component ///
//* Interpretation :
// A class called 'component' receives a parameter called 'payload' when called.
// Get tagName, state, and props from 'payload'.
// Then, the contents stored in each variable are assigned to each corresponding variable using 'this'.
// By specifying it through 'this', all methods(render()) created in the class can refer to it with the keyword 'this'.
// To define this class, specify the tag to be displayed on the web page and define the data to be included in the tag.
class $81e8a9e6cf7baa7d$export$16fa2f45be04daa8 {
    constructor(payload = {}){
        const { tagName: tagName = "div" , state: state = {} , props: props = {}  } = payload;
        this.el = document.createElement(tagName);
        // It declares so that it can be used in this render().
        // 'state' means the data that the child will affect the parent's data
        this.state = state;
        // 'props' means the data parents give to children.
        this.props = props;
        this.render();
    // The values set above can be changed through 'render()'. => Other components can have their own appearance based on the values and rules specified here.
    }
    render() {}
}
function $81e8a9e6cf7baa7d$var$routeRender(routes) {
    // Check if hash is attached to the address part, and blocks errors that occur '***'.
    // And automatically move to the screen where the component is located.
    if (!location.hash) history.replaceState(null, "", "/#/"); // Moves a window without leaving history. -> Sets the address of the initial screen.
    //* Scope the movie app specified in app.js
    const routerView = document.querySelector("router-view");
    // http://localhost:1234/#/about?name=youjun
    // location.hash = #/about?name=youjun
    const [hash, queryString = ""] = location.hash.split("?");
    const query = queryString.split("&").reduce((acc, cur)=>{
        const [key, value] = cur.split("=");
        acc[key] = value;
        return acc; // => Return value according to key(Name) in object form.
    }, {});
    history.replaceState(query, ""); // The query is stored in the state property of the history object.
    // In other words, through the state of history, the query statement stored in the address can be preprocessed, stored, and then used.
    // Check if the hash entered in the current page actually exist => If so, render the page => if not, error
    const currentRoute = routes.find((route)=>new RegExp(`${route.path}/?$`).test(hash));
    // Initialization of 'router-view'
    if (routerView) {
        routerView.innerHTML = "";
        // Assign to routerView
        currentRoute && routerView.append(new currentRoute.component().el);
    }
    // When moving the page, the scroll position is fixed at the top.
    window.scrollTo(0, 0);
}
function $81e8a9e6cf7baa7d$export$baddd0131ee8c05b(routes) {
    return function() {
        window.addEventListener("popstate", ()=>{
            // popstate : Fire when address part changes
            $81e8a9e6cf7baa7d$var$routeRender(routes);
        });
        $81e8a9e6cf7baa7d$var$routeRender(routes);
    };
}
class $81e8a9e6cf7baa7d$export$390f32400eaf98c9 {
    constructor(state){
        // state to save
        this.state = {};
        // state to observe
        this.observers = {};
        for(const key in state)// Use 'defineProperty' to execute the necessary function whenever a new value is assigned to the existing data.
        // Through the 'get' function, you can get the data that the actual state has.
        // A new value is assigned using the 'set' function.
        Object.defineProperty(this.state, key, {
            get: ()=>state[key],
            set: (val)=>{
                state[key] = val;
                // Checking whether 'this.observers[key]' is an array means that it determines whether or not to change/create a component with the changed data.
                // In other words, if data changed by a certain event creates a new component or changes an existing state, it is necessary to create 'this.observers[key]' as an array.
                if (Array.isArray(this.observers[key])) // If there is a callback to call => prevent errors.
                this.observers[key].forEach((observer)=>{
                    observer(val);
                });
            }
        });
    }
    // cb = callback function
    // Through this function, specify the objects and events to observe
    // this.observers['message'] = () => {}
    // { message: () => {} } => Only one function can be registered.
    // That is, only one component/function can be performed. Cannot affect more than one component at the same time.
    // Can register and use various functions in the following way.
    // { message: [ () => {}, () => {}, () => {} ] }
    subscribe(key, cb) {
        Array.isArray(this.observers[key]) ? this.observers[key].push(cb) : this.observers[key] = [
            cb
        ];
    }
}



class $6488ad9fef577b9d$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    //! public state = {} as State로 선언하면 추후 빈 객체에 따라 잘못된 결과물이 나올 수 있다. 
    constructor(){
        super({
            tagName: "header",
            state: {
                menus: [
                    {
                        name: "Search",
                        href: "#/"
                    },
                    {
                        name: "Movie",
                        href: "#/movie?id=tt4520988"
                    },
                    {
                        name: "About",
                        href: "#/about"
                    }
                ]
            }
        });
        // 페이지가 바뀔 때마다 새로 랜더링 => class active 적용
        window.addEventListener("popstate", ()=>{
            this.render();
        });
    }
    render() {
        this.el.innerHTML = /* html */ `
    <a href="#/" class="logo">
      <span>OMDbAPI</span>.COM
    </a>
    <nav>
      <ul>
        ${this.state.menus.map((menu)=>{
            // Address of page to move to
            const href = menu.href.split("?")[0];
            // address of real page
            const hash = location.hash.split("?")[0];
            const isActive = href === hash;
            return /* html */ `
          <li>
            <a href="${menu.href}" class="${isActive ? "active" : ""}">
              ${menu.name}
            </a>
          </li>
          `;
        }).join("")}
      </ul>
    </nav>
    <a href="#/about" class="user">
      <img src="https://lh3.googleusercontent.com/a/AAcHTtcg-XuKSKFMKu4nzKQdS1o-en3j5GsC_-C9I7kUyA=s576-c-no" alt="User">
    </a>
    `;
    }
}




var $9f00f93a4d28fd0f$export$2e2bcd8739ae039 = new (0, $81e8a9e6cf7baa7d$export$390f32400eaf98c9)({
    photo: "https://lh3.googleusercontent.com/a/AAcHTtcg-XuKSKFMKu4nzKQdS1o-en3j5GsC_-C9I7kUyA=s576-c-no",
    name: "ReasonJun / Lee Eui Jun",
    email: "tndhworl1998@gmail.com",
    blog: "https://reasonjun.tistory.com/",
    github: "https://github.com/YouJun-IWON",
    repository: "https://github.com/YouJun-IWON/movie-app"
});


class $af4f8136ffd7faf7$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tagName: "footer"
        });
    }
    render() {
        const { github: github , repository: repository  } = (0, $9f00f93a4d28fd0f$export$2e2bcd8739ae039).state;
        this.el.innerHTML = /* html */ `
    <div>
      <a href="${repository}">
        Github Repository
      </a>
  </div>
  <div>
    <a href="${github}">
      ${new Date().getFullYear()}
      ReasonJun
    </a>
  </div>
    `;
    }
}


class $2ae89aad8d89d959$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    render() {
        const theHeader = new (0, $6488ad9fef577b9d$export$2e2bcd8739ae039)().el;
        const routerView = document.createElement("router-view");
        const theFooter = new (0, $af4f8136ffd7faf7$export$2e2bcd8739ae039)().el;
        this.el.append(theHeader, routerView, theFooter);
    }
}


//! routes :
// Specifies the web list to be displayed in the html part specified in 'app.js'.
// List each web page path through an array and designate a component to be displayed on each page through an object.

//! Home.js
// The home screen is composed of components

//! Home.js
// Compose a headline in Home.

class $1bf7e69fb47f344b$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("headline");
        this.el.innerHTML = /* html */ `
      <h1>
        <span>OMDb API</span><br />
        THE OPEN<br />
        MOVIES DATABASE
      </h1>
			<p>
  			The OMDb API is a RESTful web service to obtain movie information,
  			all content and images on the site are contributed and maintained by our users.<br />
  			If you find this service useful, please consider making a one-time donation or become a patron.
			</p>
        `;
    }
}


//! Search.js
// Configure the search component of the home screen.
// As much as need to specify movie data based on search results,
// Connect with movie.js in the store folder.

//! movie.js
// Designate movie data that can be continuously changed and process according to the situation.
// It determines the format of movie data to use and has functions that can affect this format.

const $6519604fa6fd3eb8$var$store = new (0, $81e8a9e6cf7baa7d$export$390f32400eaf98c9)({
    searchText: "",
    page: 1,
    pageMax: 1,
    movies: [],
    movie: {},
    loading: false,
    message: "Search for the movie title!"
});
var $6519604fa6fd3eb8$export$2e2bcd8739ae039 = $6519604fa6fd3eb8$var$store;
const $6519604fa6fd3eb8$export$b0c4d3ac9887d994 = async (page)=>{
    $6519604fa6fd3eb8$var$store.state.loading = true; // Setting the loading screen to be shown before the result screen.
    $6519604fa6fd3eb8$var$store.state.page = page; // When '더보기' is clicked, the page value that becomes + 1 is saved.
    // When a new search event occurs(when page = 1 is specified), the contents stored in the existing array are initialized.
    if (page === 1) {
        $6519604fa6fd3eb8$var$store.state.movies = [];
        $6519604fa6fd3eb8$var$store.state.message = "";
    }
    // Make it possible to handle errors so that javascript does not stop (due to network errors).
    try {
        const res = await fetch("/api/movie.js", {
            method: "POST",
            body: JSON.stringify({
                title: $6519604fa6fd3eb8$var$store.state.searchText,
                page: page
            })
        });
        const { Search: Search , totalResults: totalResults , Response: Response , Error: Error  } = await res.json();
        if (Response === "True") {
            // Accumulate page content.
            $6519604fa6fd3eb8$var$store.state.movies = [
                ...$6519604fa6fd3eb8$var$store.state.movies,
                ...Search
            ];
            // Check the maximum outputable page through a variable called totalResults.
            $6519604fa6fd3eb8$var$store.state.pageMax = Math.ceil(Number(totalResults) / 10);
        } else {
            $6519604fa6fd3eb8$var$store.state.message = Error;
            $6519604fa6fd3eb8$var$store.state.pageMax = 1;
        }
    } catch (error) {
        console.log("searchMovies error:", error);
    } finally{
        $6519604fa6fd3eb8$var$store.state.loading = false;
    }
};
const $6519604fa6fd3eb8$export$e7daf9f9f7371f9a = async (id)=>{
    try {
        const res = await fetch("/api/movie.js", {
            method: "POST",
            body: JSON.stringify({
                id: id
            })
        });
        $6519604fa6fd3eb8$var$store.state.movie = await res.json();
    } catch (error) {
        console.log("getMovieDetails error:", error);
    }
};


class $20431fda5c575689$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("search");
        this.el.innerHTML = /* html */ `
    <!-- value: Prevents the value entered in the search box from being initialized when going back. -->
					<input value="${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText}" placeholder="Enter the movie title to search!" />
					<button class="btn btn-primary">
						Search!
					</button>
        `;
        const inputEl = this.el.querySelector("input");
        inputEl?.addEventListener("input", ()=>{
            (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText = inputEl.value;
        });
        inputEl?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter" && (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText.trim()) (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)(1);
        });
        const btnEl = this.el.querySelector(".btn");
        btnEl?.addEventListener("click", ()=>{
            if ((0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.searchText.trim()) (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)(1);
        });
    }
}


//! MovieList.js
// Configure the movie list component of the home screen.
// If there is a value (input value) that changes while tracking the state of movieStore,
// Shows the movieStore.state.movies value obtained through 'Search.js => movie.js => youjun.js'.



class $1c75024113bbd448$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    // Will receive data through the parent component (MovieList.js) and use it. => props
    constructor(props){
        super({
            props: props,
            tagName: "a"
        });
    }
    render() {
        // console.log('this is state:' + JSON.stringify(this.state));
        console.log("this is props:" + JSON.stringify(this.props));
        const { movie: movie  } = this.props;
        this.el.setAttribute("href", `#/movie?id=${movie.imdbID}`);
        this.el.classList.add("movie");
        // When outputting with a img tag, the layout may be broken due to the size of each different poster.
        // So, designating as in the code below, determine the size of the 'a' tag and unify it.
        this.el.style.backgroundImage = `url(${movie.Poster})`;
        this.el.innerHTML = /* html */ `
    <div class="info">
        <div class="year">
            ${movie.Year}
        </div>
        <div class="title">
            ${movie.Title}
        </div>
    </div>
    `;
    }
}


class $7a11c170c3fb4054$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    // Create a constructor so that when a certain condition occurs, movieStore.subscribe can be run (so that the web page can be updated whenever a new search is made.)
    constructor(){
        super();
        // Among the values stored in the movieStore, the object named movies is monitored.
        // It is re-render() every time new movies are updated
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("movies", ()=>{
            this.render();
        });
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("loading", ()=>{
            this.render();
        });
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("message", ()=>{
            this.render();
        });
    }
    render() {
        this.el.classList.add("movie-list");
        this.el.innerHTML = /* html */ `
        ${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.message ? `<div class="message">${(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.message}</div>` : '<div class="movies"></div>'}
        <div class="the-loader hide"></div>
        `;
        const moviesEl = this.el.querySelector(".movies");
        // ? : remove error
        moviesEl?.append(...(0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.movies.map((movie)=>new (0, $1c75024113bbd448$export$2e2bcd8739ae039)({
                movie: movie
            }).el // movie = movie : movie
        ));
        const loaderEl = this.el.querySelector(".the-loader");
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.loading ? loaderEl?.classList.remove("hide") : loaderEl?.classList.add("hide");
    }
} //! The reason for specifying the constructor as above.
 /*
class Polygon {
    constructor() {
      this.name = 'Polygon';
      this.render()
    }
    render() {
      console.log('hello')
      this.name = this.name.concat('-wow')
    }
  }
  
  const poly1 = new Polygon();
  
  console.log(poly1.name);
  */  // console.log =>
 // "hello"
 // "Polygon-wow"
 //* Interpretation :
 // Show the result of executing the function specified in the constructor.
 // This means that if you use the class constructor, you can modify the variables to be used through various functions and get the result.




class $3ebe9f9f5c4af79c$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    constructor(){
        super({
            tagName: "button"
        });
        // A function that shows the 'more' button depending on the situation whenever pageMax is updated.
        (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).subscribe("pageMax", ()=>{
            const { page: page , pageMax: pageMax  } = (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state;
            pageMax > page ? this.el.classList.remove("hide") : this.el.classList.add("hide");
        });
    }
    render() {
        this.el.classList.add("btn", "view-more", "hide");
        this.el.textContent = "View more..";
        this.el.addEventListener("click", async ()=>{
            this.el.classList.add("hide");
            await (0, $6519604fa6fd3eb8$export$b0c4d3ac9887d994)((0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.page + 1);
        });
    }
}


class $8f966fc6c3ddd7f9$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    render() {
        const headline = new (0, $1bf7e69fb47f344b$export$2e2bcd8739ae039)().el;
        const search = new (0, $20431fda5c575689$export$2e2bcd8739ae039)().el;
        const movieList = new (0, $7a11c170c3fb4054$export$2e2bcd8739ae039)().el;
        const movieListMore = new (0, $3ebe9f9f5c4af79c$export$2e2bcd8739ae039)().el;
        this.el.classList.add("container");
        this.el.append(headline, search, movieList, movieListMore);
    }
}




class $9e7e61b7f62dc712$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    async render() {
        this.el.classList.add("container", "the-movie");
        // Specifies the part to be displayed to insert the 'skeleton'.
        this.el.innerHTML = /* html */ `
      <div class="poster skeleton"></div>
        <div class="specs">
          <div class="title skeleton"></div>
          <div class="labels skeleton"></div>
          <div class="plot skeleton"></div>
        </div>
    `;
        // When entering the Movie page, the id value of 'history.state' saved by the query statement of the address is put into 'getMovieDetails'.
        // Then, the desired data is entered into 'movieStore.state.movie' through 'movie.js'.
        await (0, $6519604fa6fd3eb8$export$e7daf9f9f7371f9a)(history.state.id);
        // Since the id is stored as object data in the history state through the router function, the data can be retrieved as above.
        console.log((0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state.movie);
        const { movie: movie  } = (0, $6519604fa6fd3eb8$export$2e2bcd8739ae039).state;
        // image resizing
        const bigPoster = movie.Poster.replace("SX300", "SX700");
        this.el.innerHTML = /* html */ `
    <div style="background-image: url(${bigPoster})" class="poster"></div>
    <div class="specs">
      <div class="title">${movie.Title}</div>
      <div class="labels">
        <span>${movie.Released}</span>
        <!-- &nbsp; = space -->
        &nbsp;/&nbsp;
        <span>${movie.Runtime}</span>
        &nbsp;/&nbsp;
        <span>${movie.Country}</span>
      </div>
      <div class="plot">${movie.Plot}</div>
      <div>
        <h3>Ratings</h3>
        ${movie.Ratings.map((rating)=>{
            return `<p>${rating.Source} - ${rating.Value}</p>`;
        }).join("")}
      </div>
      <div>
        <h3>Actors</h3>
        <p>${movie.Actors}</p>
      </div>
      <div>
        <h3>Director</h3>
        <p>${movie.Director}</p>
      </div>
      <div>
        <h3>Production</h3>
        <p>${movie.Production}</p>
      </div>
      <div>
        <h3>Genre</h3>
        <p>${movie.Genre}</p>
      </div>
    </div>
    `;
    }
}




class $c06da9a08b0e3020$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    render() {
        const { photo: photo , name: name , email: email , github: github , blog: blog  } = (0, $9f00f93a4d28fd0f$export$2e2bcd8739ae039).state;
        this.el.classList.add("container", "about");
        this.el.innerHTML = /* html */ `
      <div style="background-image: url(${photo});" class="photo"></div>
      <p class="name">${name}</p>
      <p><a href="https://mail.google.com/mail/?view=cm&fs=1&to=${email}" target="_blank">${email}</a></p>
      <p><a href="${github}" target="_blank">GitHub</a></p>
      <p><a href="${blog}" target="_blank">Blog</a></p>
    `;
    }
}



class $651330ec7a632937$export$2e2bcd8739ae039 extends (0, $81e8a9e6cf7baa7d$export$16fa2f45be04daa8) {
    render() {
        this.el.classList.add("container", "not-found");
        this.el.innerHTML = /* html */ `
    <h1>
      Sorry.. <br>
      Page Not Found
    </h1>
    `;
    }
}


var // Here, the component designated according to the path becomes the 'router-view' of app.js.
$573f2dca97842810$export$2e2bcd8739ae039 = (0, $81e8a9e6cf7baa7d$export$baddd0131ee8c05b)([
    {
        path: "#/",
        component: (0, $8f966fc6c3ddd7f9$export$2e2bcd8739ae039)
    },
    {
        path: "#/movie",
        component: (0, $9e7e61b7f62dc712$export$2e2bcd8739ae039)
    },
    {
        path: "#/about",
        component: (0, $c06da9a08b0e3020$export$2e2bcd8739ae039)
    },
    {
        path: ".*",
        component: (0, $651330ec7a632937$export$2e2bcd8739ae039)
    }
]);


// When set as above, find the index value by default.
const $ad2bcec7a0192558$var$root = document.querySelector("#root");
// element composition
$ad2bcec7a0192558$var$root?.append(new (0, $2ae89aad8d89d959$export$2e2bcd8739ae039)().el);
// Need to have an element first.
// Then can make routes to assign to each element.
// Add function of each element
(0, $573f2dca97842810$export$2e2bcd8739ae039)();
// immediate function.
(async ()=>{
    const res = await fetch("/api/test");
    const json = await res.json();
    console.log("/api/test/", json);
})();


//# sourceMappingURL=index.1630993b.js.map
